import React from 'react';
import { Box, Typography, Grid, Container, useTheme } from '@mui/material';
import { Lightbulb as Step1Icon, FileCopy as Step2Icon, UploadFile as Step3Icon } from '@mui/icons-material';

// Steps data structure
const steps = [
    {
        icon: <Step1Icon sx={{ width: '60px', height: '60px', marginBottom: 2 }} />,
        title: 'Ask Anything',
        description: 'You can ask anything related to your subject, topic, or concept. Just type your question, and Glassyfied\'s AI will provide detailed answers and explanations.',
    },
    {
        icon: <Step2Icon sx={{ width: '60px', height: '60px', marginBottom: 2 }} />,
        title: 'Upload Images',
        description: 'If you have a question about an image, you can upload it directly, and Glassyfied will extract the relevant content and provide an answer.',
    },
    {
        icon: <Step3Icon sx={{ width: '60px', height: '60px', marginBottom: 2 }} />,
        title: 'Create & Save Notes',
        description: 'You can save important information, generate notes, and organize them directly in the app for future reference.',
    },
];

const HowItWorks = () => {
    const theme = useTheme();

    return (
        <Box sx={{ backgroundColor: 'grey.A100', padding: theme.spacing(8, 2) }}>
            <Container maxWidth="lg">
                {/* Title */}
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        textAlign: 'center',
                        marginBottom: theme.spacing(4),
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                    }}
                >
                    How Glassyfied Works
                </Typography>

                {/* Subtitle */}
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 400,
                        textAlign: 'center',
                        marginBottom: theme.spacing(6),
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                    }}
                >
                    Glassyfied simplifies your learning process with powerful AI tools that instantly provide answers, explanations, and notes on any subject. Here's how it works:
                </Typography>

                {/* Steps Grid */}
                <Grid container spacing={4} justifyContent="center">
                    {steps.map((step, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index} sx={{ textAlign: 'center' }}>
                            {step.icon}
                            <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: theme.spacing(1) }}>
                                {step.title}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 400 }}>
                                {step.description}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default HowItWorks;
